/**
 * @format
 */
import { Component, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";
import { Subject } from "rxjs/internal/Subject";
import { Observable, Subscription } from "rxjs/index";
import { SmsConversionService } from "../sms-conversion.service";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";

export interface TagViewItem {
   ar2tag: string;
   regExp: RegExp;
   ar3tag: string;
   safeHtml: SafeHtml;
}

@Component({
   selector: "tag-mapping-modal",
   templateUrl: "tag-mapping-modal.component.html",
   styleUrls: ["tag-mapping-modal.component.css"],
   encapsulation: ViewEncapsulation.None,
})
export class TagMappingModalComponent implements OnInit, OnDestroy {
   templateModelImageVariable: string;
   displayCopy: boolean;
   cols: { field: string; header: string; width: string }[];
   onClose: Subject<{ isConfirmed: boolean; features: Array<Partial<TagViewItem>> }>;
   tagViewItems: Array<Partial<TagViewItem>>;

   _sub: Subscription = new Subscription();

   constructor(
      private modalRef: BsModalRef,
      private smsConversionService: SmsConversionService,
      private sanitized: DomSanitizer
   ) {
      this.tagViewItems = this.smsConversionService.getTagItemList().map((item) => {
         return { ...item, safeHtml: this.getTagAsElement(item.ar3tag) };
      });
   }

   ngOnInit(): void {
      this.initializeTagMappingTable();
   }

   ngOnDestroy(): void {
      this._sub.unsubscribe();
   }

   closeDialog(): void {
      this.modalRef.hide();
   }

   private getTagAsElement(ar3tag: string): SafeHtml {
      return this.sanitized.bypassSecurityTrustHtml(ar3tag);
   }

   private initializeTagMappingTable(): void {
      this.onClose = new Subject();
      this.cols = [
         { field: "ar2tag", header: "AR2 tag", width: "50%" },
         { field: "ar3tag", header: "AR3 tag", width: "50%" },
      ];
   }
}
